// System
import { useDispatch } from 'react-redux';
import { Button, Typography } from '@mui/material';
// Components
import { AtLocator } from '@Components/shared/locators/AtLocator';
import { ClosableModal } from '@Components/shared/dialogs/ClosableModal';
import { CreateDialogLayout } from '@Components/shared/layouts/CreateDialogLayout';
import { CreateDialogFooterLayout } from '@Components/shared/layouts/CreateDialogFooterLayout';
// Hooks
import { useAviatorRoleDrawer } from '@Modal/hooks/aviatorRoles/useAviatorRoleDrawer';
// Types
import { AppDispatch } from 'src/app/store';
// Graphql
import { useAviatorPermissions } from '@Modal/hooks/aviatorRoles/useAviatorPermissions';

export const SelectedRolePermissionDeleteModalDialog = () => {
  const dispatch = useDispatch<AppDispatch>();

  const { selectedAviatorRoleData, handleAviatorRoleRowClick } = useAviatorRoleDrawer();
  const {
    selectedRolePermissionToDelete,
    handleDeleteSelectedRolePermission,
    showSelectedRolePermissionDeleteModal,
    setShowSelectedRolePermissionDeleteModal,
  } = useAviatorPermissions();
  const { id, name } = selectedAviatorRoleData;

  const handleDeleteClick = async () => {
    await handleDeleteSelectedRolePermission(id, selectedRolePermissionToDelete);
    handleAviatorRoleRowClick(id);
  };

  return (
    <ClosableModal
      name="SetupAviatorRoleDeleteModalDialog"
      title="Delete Aviator Role"
      open={showSelectedRolePermissionDeleteModal}
      onClose={() => dispatch(setShowSelectedRolePermissionDeleteModal(false))}
      sx={{ width: '592px' }}
    >
      <CreateDialogLayout>
        <Typography variant="body1">
          Are you sure you want to delete permission{' '}
          <Typography sx={{ display: 'inline', fontWeight: 'bold' }}>
            {selectedRolePermissionToDelete}
          </Typography>{' '}
          of <Typography sx={{ display: 'inline', fontWeight: 'bold' }}>{name}</Typography>?
        </Typography>
        <CreateDialogFooterLayout>
          <AtLocator type="button" name="Cancel">
            <Button
              variant="outlined"
              color="inherit"
              onClick={() => dispatch(setShowSelectedRolePermissionDeleteModal(false))}
            >
              Cancel
            </Button>
          </AtLocator>
          <Button variant="contained" color="error" onClick={handleDeleteClick}>
            Delete
          </Button>
        </CreateDialogFooterLayout>
      </CreateDialogLayout>
    </ClosableModal>
  );
};
